<template>
  <!-- eslint-disable -->
  <div class="dashboard-layout">
    <!-- Sidebar Toggle para móviles -->
    <div class="sidebar-toggle" @click="toggleSidebar">
      <i class="fas fa-bars"></i>
    </div>
    
    <!-- Sidebar -->
    <div class="sidebar" :class="{ 'sidebar-active': sidebarActive }">
      <div class="sidebar-close" @click="toggleSidebar">
        <i class="fas fa-times"></i>
      </div>
      <SideNav />
    </div>

    <!-- Contenido principal -->
    <div class="main-content">
      <TopNav />

      <div class="page-container">
        <!-- Header de página -->
        <div class="page-header">
          <div class="header-content">
            <h1 class="page-title">Modificar precios de servicios</h1>
            <p class="page-subtitle">Gestiona los precios de servicios por comuna</p>
          </div>
          <div class="header-actions">
            <div class="search-container">
              <i class="fas fa-search search-icon"></i>
              <input 
                type="text" 
                class="search-input" 
                placeholder="Buscar comuna..." 
                v-model="searchTerm"
              >
            </div>
          </div>
        </div>

        <!-- Alertas -->
        <transition name="fade">
          <div v-if="error" class="alert alert-danger">
            <i class="fas fa-exclamation-circle mr-2"></i>
            {{ error }}
            <button class="alert-close" @click="error = ''">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </transition>

        <transition name="fade">
          <div v-if="success" class="alert alert-success">
            <i class="fas fa-check-circle mr-2"></i>
            {{ success }}
            <button class="alert-close" @click="success = ''">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </transition>

        <!-- Loader -->
        <div v-if="!loaded" class="loader-container">
          <Loader />
          <p class="loading-text">Cargando datos de comunas...</p>
        </div>

        <!-- Contenido principal -->
        <div v-else class="content-grid">
          <!-- Tarjeta de estadísticas -->
          <div class="stats-card">
            <div class="stat-item">
              <div class="stat-icon">
                <i class="fas fa-map-marker-alt"></i>
              </div>
              <div class="stat-info">
                <h3 class="stat-value">{{ tabla.length }}</h3>
                <p class="stat-label">Comunas</p>
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-icon">
                <i class="fas fa-dollar-sign"></i>
              </div>
              <div class="stat-info">
                <h3 class="stat-value">{{ preciosConfigurados }}</h3>
                <p class="stat-label">Precios configurados</p>
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-icon">
                <i class="fas fa-clock"></i>
              </div>
              <div class="stat-info">
                <h3 class="stat-value">{{ ultimaActualizacion }}</h3>
                <p class="stat-label">Última actualización</p>
              </div>
            </div>
          </div>

          <!-- Tabla de precios -->
          <div class="data-card">
            <div class="card-header">
              <h2 class="card-title">Precios por comuna</h2>
              <div class="card-actions">
                <button class="btn-outline" @click="cargarDatos">
                  <i class="fas fa-sync-alt"></i> Actualizar
                </button>
              </div>
            </div>
            
            <div class="table-container">
              <table class="data-table">
                <thead>
                  <tr>
                    <th class="th-comuna">Comuna</th>
                    <th class="th-precio">Precio ($)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in filteredTabla" :key="index" :class="{ 'row-modified': isModified(index) }">
                    <td class="td-comuna">
                      <div class="comuna-info">
                        <i class="fas fa-map-marker-alt comuna-icon"></i>
                        <span>{{ item.nombre }}</span>
                      </div>
                    </td>
                    <td class="td-precio">
                      <div class="price-input-container">
                        <span class="price-symbol">$</span>
                        <input
                          type="number"
                          min="0"
                          v-model="tabla[getOriginalIndex(index)].valor"
                          class="price-input"
                          placeholder="Sin precio"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="card-footer">
              <div class="pagination">
                <span class="pagination-info">Mostrando {{ filteredTabla.length }} de {{ tabla.length }} comunas</span>
              </div>
              <button class="btn-primary" @click="guardarCambios">
                <i class="fas fa-save"></i> Guardar cambios
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import SideNav from '@/components/SideNav.vue'
import TopNav from '@/components/TopNav.vue'
import Loader from '@/components/Loader.vue'

export default {
  name: 'ModificarCostoServicioComuna',
  components: {
    SideNav,
    TopNav,
    Loader
  },
  data() {
    return {
      tabla: [],
      originalValues: [], // Para rastrear cambios
      fields: [
        { key: 'nombre', label: 'Comuna' },
        { key: 'valor', label: 'Precio ($)' }
      ],
      loaded: false,
      error: '',
      success: '',
      prestadorId: null,
      searchTerm: '',
      sidebarActive: false,
      ultimaActualizacion: 'Hoy'
    }
  },
  computed: {
    filteredTabla() {
      if (!this.searchTerm) return this.tabla
      
      const searchLower = this.searchTerm.toLowerCase()
      return this.tabla.filter(item => 
        item.nombre.toLowerCase().includes(searchLower)
      )
    },
    preciosConfigurados() {
      return this.tabla.filter(item => item.valor && item.valor !== '').length
    },
    // Mapeo para encontrar el índice original después del filtrado
    indexMap() {
      return this.filteredTabla.map(item => 
        this.tabla.findIndex(tableItem => tableItem.comuna_id === item.comuna_id)
      )
    }
  },
  created() {
    this.cargarDatos()
  },
  methods: {
    toggleSidebar() {
      this.sidebarActive = !this.sidebarActive
    },
    formatPrice(price) {
      return new Intl.NumberFormat('es-CL').format(price)
    },
    getOriginalIndex(filteredIndex) {
      return this.indexMap[filteredIndex]
    },
    isModified(filteredIndex) {
      const originalIndex = this.getOriginalIndex(filteredIndex)
      if (originalIndex < 0) return false
      
      const original = this.originalValues[originalIndex]
      const current = this.tabla[originalIndex].valor
      
      return original !== current
    },
    cargarDatos() {
      this.loaded = false
      this.error = ''
      this.success = ''

      axios
        .get(`${window.hostname}/api/admin/costo_servicio_por_comuna`)
        .then((response) => {
          const data = response.data
          this.prestadorId = data.prestador_id

          const comunas = data.comunas
          const costos = data.costos

          this.tabla = Object.keys(comunas).map((id) => {
            const comunaId = parseInt(id, 10)
            return {
              comuna_id: comunaId,
              nombre: comunas[id],
              valor: costos[id] !== -1 ? costos[id] : ''
            }
          })
          
          // Guardar valores originales para detectar cambios
          this.originalValues = this.tabla.map(item => item.valor)

          this.loaded = true
          
          // Actualizar timestamp
          const now = new Date()
          this.ultimaActualizacion = `${now.getHours()}:${String(now.getMinutes()).padStart(2, '0')}`
        })
        .catch((error) => {
          console.error('Error al cargar datos:', error)
          this.error = 'Error al cargar los datos. Por favor, intente nuevamente.'
          this.loaded = true
        })
    },
    guardarCambios() {
      this.error = ''
      this.success = ''

      const nuevosCostos = {}

      this.tabla.forEach((item) => {
        if (item.valor === '' || item.valor === null) {
          nuevosCostos[item.comuna_id] = '-1'
        } else {
          nuevosCostos[item.comuna_id] = item.valor
        }
      })

      axios
        .post(`${window.hostname}/api/admin/costo_servicio_por_comuna`, {
          prestador_id: this.prestadorId,
          nuevos_costos: nuevosCostos
        })
        .then(() => {
          this.success = 'Cambios guardados exitosamente.'
          this.cargarDatos()
        })
        .catch((error) => {
          console.error('Error al guardar cambios:', error)
          this.error = 'Error al guardar los cambios. Por favor, intente nuevamente.'
        })
    }
  }
}
</script>

<style scoped>
/* Variables de colores */
:root {
  --primary: #4361ee;
  --primary-light: #4895ef;
  --primary-dark: #3f37c9;
  --success: #4caf50;
  --danger: #f44336;
  --warning: #ff9800;
  --info: #2196f3;
  --dark: #333;
  --light: #f8f9fa;
  --gray: #6c757d;
  --gray-light: #e9ecef;
  --gray-dark: #495057;
  --white: #ffffff;
  --shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 12px 24px -6px rgba(0, 0, 0, 0.12), 0 6px 12px -4px rgba(0, 0, 0, 0.07);
  --border-radius: 16px;
  --border-radius-sm: 12px;
  --border-radius-lg: 24px;
  --border-radius-xl: 32px;
  --border-radius-pill: 50px;
}

/* Reset y estilos base */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Layout principal */
.dashboard-layout {
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fb;
  position: relative;
}

/* Sidebar */
.sidebar {
  width: 260px;
  background: linear-gradient(180deg, #3a0ca3 0%, #4361ee 100%);
  color: white;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  box-shadow: var(--shadow);
  transition: transform 0.3s ease;
  border-top-right-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
}

.sidebar-close {
  display: none;
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.sidebar-toggle {
  display: none;
  position: fixed;
  top: 15px;
  left: 15px;
  z-index: 999;
  background: var(--primary);
  color: white;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: var(--shadow);
}

/* Contenido principal */
.main-content {
  flex: 1;
  margin-left: 260px;
  width: calc(100% - 260px);
  transition: margin-left 0.3s ease, width 0.3s ease;
}

.page-container {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

/* Header de página */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  flex-wrap: wrap;
  gap: 20px;
}

.header-content {
  flex: 1;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: var(--dark);
  margin-bottom: 6px;
}

.page-subtitle {
  color: var(--gray);
  font-size: 16px;
}

.header-actions {
  display: flex;
  gap: 16px;
}

.search-container {
  position: relative;
  width: 280px;
}

.search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--gray);
}

.search-input {
  width: 100%;
  padding: 12px 12px 12px 44px;
  border: 1px solid var(--gray-light);
  border-radius: var(--border-radius-pill);
  font-size: 15px;
  transition: all 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 4px rgba(67, 97, 238, 0.2);
}

/* Alertas */
.alert {
  padding: 18px;
  border-radius: var(--border-radius);
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  position: relative;
}

.alert-danger {
  background-color: rgba(244, 67, 54, 0.1);
  color: var(--danger);
  border-left: 4px solid var(--danger);
}

.alert-success {
  background-color: rgba(76, 175, 80, 0.1);
  color: var(--success);
  border-left: 4px solid var(--success);
}

.alert-close {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  opacity: 0.7;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert-close:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.05);
}

/* Animaciones */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Loader */
.loader-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  gap: 20px;
}

.loading-text {
  color: var(--gray);
  font-size: 18px;
}

/* Grid de contenido */
.content-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 28px;
}

/* Tarjeta de estadísticas */
.stats-card {
  background: white;
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow);
  padding: 24px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 20px;
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  background: linear-gradient(135deg, var(--primary-light), var(--primary));
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.stat-info {
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: var(--dark);
  margin-bottom: 6px;
}

.stat-label {
  color: var(--gray);
  font-size: 15px;
}

/* Tarjeta de datos */
.data-card {
  background: white;
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow);
  overflow: hidden;
}

.card-header {
  padding: 24px;
  border-bottom: 1px solid var(--gray-light);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--dark);
}

.card-actions {
  display: flex;
  gap: 12px;
}

/* Tabla */
.table-container {
  overflow-x: auto;
  border-radius: var(--border-radius);
}

.data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.data-table th,
.data-table td {
  padding: 18px 24px;
  text-align: left;
}

.data-table th {
  background-color: #f9fafc;
  font-weight: 600;
  color: var(--gray-dark);
  position: sticky;
  top: 0;
}

.data-table th:first-child {
  border-top-left-radius: var(--border-radius-sm);
}

.data-table th:last-child {
  border-top-right-radius: var(--border-radius-sm);
}

.data-table tr {
  border-bottom: 1px solid var(--gray-light);
  transition: background-color 0.2s;
}

.data-table tr:last-child td:first-child {
  border-bottom-left-radius: var(--border-radius-sm);
}

.data-table tr:last-child td:last-child {
  border-bottom-right-radius: var(--border-radius-sm);
}

.data-table tr:hover {
  background-color: #f9fafc;
}

.th-comuna {
  width: 60%;
}

.th-precio {
  width: 40%;
}

.td-comuna {
  font-weight: 500;
}

.comuna-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.comuna-icon {
  color: var(--primary);
  font-size: 18px;
}

.td-precio {
  width: 220px;
}

.price-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.price-symbol {
  position: absolute;
  left: 16px;
  color: var(--gray);
  font-weight: 500;
}

.price-input {
  width: 100%;
  padding: 12px 12px 12px 28px;
  border: 1px solid var(--gray-light);
  border-radius: var(--border-radius-pill);
  font-size: 15px;
  transition: all 0.2s;
}

.price-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 4px rgba(67, 97, 238, 0.2);
}

.row-modified {
  background-color: rgba(67, 97, 238, 0.05);
}

.row-modified td:first-child {
  border-left: 4px solid var(--primary);
  padding-left: 20px;
}

/* Footer de tarjeta */
.card-footer {
  padding: 20px 24px;
  border-top: 1px solid var(--gray-light);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination {
  color: var(--gray);
  font-size: 15px;
}

/* Botones */
.btn-primary {
  background: linear-gradient(135deg, var(--primary-light), var(--primary));
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: var(--border-radius-pill);
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s;
  box-shadow: 0 4px 8px rgba(67, 97, 238, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(67, 97, 238, 0.4);
}

.btn-outline {
  background: transparent;
  color: var(--primary);
  border: 1px solid var(--primary);
  padding: 11px 20px;
  border-radius: var(--border-radius-pill);
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s;
}

.btn-outline:hover {
  background: rgba(67, 97, 238, 0.1);
}

/* Responsive */
@media (max-width: 992px) {
  .sidebar {
    transform: translateX(-100%);
  }
  
  .sidebar-active {
    transform: translateX(0);
  }
  
  .sidebar-close {
    display: flex;
  }
  
  .sidebar-toggle {
    display: flex;
  }
  
  .main-content {
    margin-left: 0;
    width: 100%;
  }
  
  .page-container {
    padding: 20px;
  }
  
  .stats-card {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .header-actions {
    width: 100%;
  }
  
  .search-container {
    width: 100%;
  }
  
  .card-footer {
    flex-direction: column;
    gap: 16px;
  }
  
  .btn-primary {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .page-container {
    padding: 16px;
  }
  
  .page-title {
    font-size: 26px;
  }
  
  .data-table th,
  .data-table td {
    padding: 14px 16px;
  }
  
  .td-precio {
    width: 140px;
  }
  
  .stats-card {
    padding: 20px;
  }
  
  .stat-icon {
    width: 48px;
    height: 48px;
    font-size: 18px;
  }
  
  .stat-value {
    font-size: 24px;
  }
}

/* Scrollbar personalizado */
.table-container::-webkit-scrollbar {
  height: 10px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: var(--border-radius-pill);
}

.table-container::-webkit-scrollbar-thumb {
  background: var(--primary-light);
  border-radius: var(--border-radius-pill);
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: var(--primary);
}
</style>